/**
 * Translation Module Exports
 *
 * PDF paragraph translation feature:
 * - Arabic to English translation via Gemini API
 * - Caching in IndexedDB
 * - Visual overlay with highlights and connection lines
 */

// Types
export type {
  PdfParagraph,
  TranslatedParagraph,
  TranslationStatus,
  StoredPageTranslation,
  TranslateRequest,
  TranslateResponse,
  DocumentTranslationState,
} from "./translationTypes.js";

// Storage
export {
  savePageTranslation,
  loadPageTranslation,
  hasPageTranslation,
  loadPageTranslations,
  clearDocumentTranslations,
  clearPageTranslation,
  getTranslatedPageIndices,
} from "./translationStorage.js";

// Service
export {
  translatePageRange,
  checkTranslationHealth,
  capturePageAsImage,
} from "./translationService.js";

// Paragraph extraction
export {
  extractParagraphsFromPage,
  extractParagraphsFromPageRange,
  getParagraphCenterY,
  getParagraphRightX,
} from "./paragraphExtraction.js";

// Color palette
export {
  TRANSLATION_COLORS,
  getColorForIndex,
  getTransparentBg,
} from "./colorPalette.js";
export type { TranslationColor } from "./colorPalette.js";

// Components
export { TranslationBlob } from "./TranslationBlob.js";
export { ArabicTextPanel } from "./ArabicTextPanel.js";
export { ConnectionLine } from "./ConnectionLine.js";
export { ParagraphHighlight } from "./ParagraphHighlight.js";
export { TranslationOverlay } from "./TranslationOverlay.js";
